import { render } from "./NewsEdit.vue?vue&type=template&id=13f4f6cf&scoped=true&ts=true"
import script from "./NewsEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsEdit.vue?vue&type=script&setup=true&lang=ts"

import "./NewsEdit.vue?vue&type=style&index=0&id=13f4f6cf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f4f6cf"],['__file',"src/components/scan/admin/NewsEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13f4f6cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13f4f6cf', __exports__)) {
    console.log('reload')
    api.reload('13f4f6cf', __exports__)
  }
  
  module.hot.accept("./NewsEdit.vue?vue&type=template&id=13f4f6cf&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('13f4f6cf', render)
  })

}


export default __exports__